import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Grunnerverv from './Grunnerverv.jsx'
import GrunnervervIcon from '../../../images/Jordskiftekrav.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class GrunnervervList extends Component {
    state = {
        grunnerverv: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getGrunnerverv = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/grunnerverv`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                grunnerverv: [...this.state.grunnerverv, ...data.grunnerverv],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
    }

    toggleGrunnerverv = () => {
        if (this.props.antall == 0) return

        if (this.state.grunnerverv.length == 0) {
            this.getGrunnerverv()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallGrunnerverv = this.state.continuationToken ? `${this.state.grunnerverv.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.toggleGrunnerverv}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={GrunnervervIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('grunnerverv')} ({antallGrunnerverv})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.grunnerverv.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.grunnerverv.map((g, index) => {return (<Grunnerverv key={g.grunnervervId} grunnerverv={g} antall={this.props.antall} isLast={index==this.state.grunnerverv.length-1} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getGrunnerverv}>
                                <span>{t('hent.grunnerverv')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(GrunnervervList)